export default __webpack_public_path__ + "static/media/AstroSquad-min2.a8c0f5f0.png";